<div class="video-container">
  <div class="video">
    <app-video [options]="options" (firstPlayed)="firstPlayed()"></app-video>
  </div>
</div>
